import { ref, object, number } from '@gogame/schemas';

export const compensationsValidationSchema = object({
  value: number()
    .max(ref('maxValue'), ({ max }) => `${max} maximum`)
    .min(ref('minValue'), ({ min }) => `${min} minimum`)
    .required('Required'),
});
